export const hiringIssueMap = {
  longCyclesWithDropoff: 'longCyclesWithDropoff',
  poorStakeholderCommunication: 'poorStakeholderCommunication',
  schedulingConflicts: 'schedulingConflicts',
  inconsistentProcess: 'inconsistentProcess',
  lackOfAutomation: 'lackOfAutomation',
} as const

export const hiringIssueDisplayMap = {
  inconsistentProcess:
    'Bottlenecks caused by unclear or inconsistent processes',
  lackOfAutomation:
    'Lack of automation in repetitive tasks like scheduling and follow-up',
  longCyclesWithDropoff: 'Long hiring cycles that lead to candidate drop-off',
  poorStakeholderCommunication:
    'Poor communication among stakeholders (recruiters, hiring managers etc.)',
  schedulingConflicts: 'Scheduling conflicts during interviews',
} as const

export type HiringIssue = keyof typeof hiringIssueMap

export type HiringIssueDisplay = (typeof hiringIssueDisplayMap)[HiringIssue]
